<template>
    <main>

        <task-editor
            v-if="tasks.addingTask"
            @close="mainStore.stopAddingTask"
            :title="$t('tasks.add_task')"
        ></task-editor>

        <task-editor
            v-if="tasks.editingTask"
            @close="mainStore.stopEditingTask"
            :task="tasks.editingTask"
            :title="$t('tasks.edit_task')"
        ></task-editor>

        <popup-modal-confirm
            v-if="tasks.deletingTask"
            :confirmText="$t('general.delete_subject', {subject: $t('tasks.this_task')})"
            :message="$t('general.confirm_delete_subject', {subject: $t('tasks.this_task')})"
            show-exclamation
            :title="$t('tasks.delete_task')+'?'"
            :working="performingDeleteRequest"
            @confirm="deleteTask(tasks.deletingTask)"
            @close="mainStore.cancelDeleteTask"
        ></popup-modal-confirm>

    </main>
</template>

<script>
import Task from '../../models/Task';
import TaskEditor from './TaskEditor.vue';
import PopupModalConfirm from './PopupModalConfirm.vue';
import * as tasks from '../../services/TaskService';
import Application from '../../models/Application';
import {mapStores} from "pinia";
import {useMainStore} from "../../state/store";
import {useRepo} from "pinia-orm";

export default {
    components: {
        'task-editor': TaskEditor,
        'popup-modal-confirm': PopupModalConfirm,
    },
    data: function () {
        return {
            performingDeleteRequest: false,
        }
    },
    computed: {
        ...mapStores(useMainStore),
        tasks() {
            return this.mainStore.tasks;
        }
    },
    methods: {
        deleteTask (task) {
            this.performingDeleteRequest = true;

            tasks.destroy(task.id).then(() => {
                useRepo(Task).destroy(task.id);
            }).then(() => {
                if (task.subject_type === 'application') {
                    const applications = useRepo(Application)
                        .where('id', task.subject_id)
                        .get()
                        .map(application => ({
                            id: application.id,
                            tasks_count: application.tasks_count - 1
                        }));
                    useRepo(Application).save(applications);
                }

                this.mainStore.cancelDeleteTask();
                this.performingDeleteRequest = false;
            });
        }
    },
}
</script>
